import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
var trimPost = function trimPost(post) {
  if (post.text.length <= 290) {
    post.textToShow = post.text;
    post.isFullText = true;
  } else {
    var _trimMetaChars = function trimMetaChars(text) {
      if (!text) return '';
      var lastChar = text.substr(text.length - 1);

      // Not digit or letter
      if (!lastChar.match(/[\w\u0430-\u044f]+/ig)) {
        text = text.slice(0, text.length - 1);
        return _trimMetaChars(text);
      }
      return text;
    };
    post.textToShow = post.text.slice(0, 276);
    var lastSpaceIndex = post.textToShow.lastIndexOf(" ");
    post.textToShow = post.textToShow.slice(0, lastSpaceIndex);
    post.textToShow = _trimMetaChars(post.textToShow);
    post.textToShow = "".concat(post.textToShow, "...");
    post.isFullText = false;
  }

  // Create get and set (reactivity for each new props)
  return Object.assign({}, post);
};
export function useFeedStore(feedName) {
  return defineStore(feedName, {
    state: function state() {
      return {
        posts: [],
        length: 1,
        new: [],
        roomName: null,
        query: {},
        minHeight: 0
      };
    },
    getters: {
      post: function post(state) {
        return function (id) {
          return state.posts.find(function (o) {
            return o.id == id;
          });
        };
      }
    },
    actions: {
      setMinHeight: function setMinHeight(height) {
        this.minHeight = height;
      },
      updateLastUse: function updateLastUse() {
        this.lastUse = new Date();
      },
      create: function create(_ref) {
        var length = _ref.length,
          roomName = _ref.roomName,
          query = _ref.query;
        this.length = length;
        this.roomName = roomName;
        this.query = query;
      },
      push: function push(posts) {
        var _this = this;
        var _iterator = _createForOfIteratorHelper(posts),
          _step;
        try {
          var _loop = function _loop() {
            var post = _step.value;
            var inFeed = _this.posts.some(function (o) {
              return o.id == post.id;
            });
            if (!inFeed) _this.posts.push(trimPost(post));
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.updateLastUse();
      },
      unshift: function unshift(posts) {
        var _this2 = this;
        var _iterator2 = _createForOfIteratorHelper(posts),
          _step2;
        try {
          var _loop2 = function _loop2() {
            var post = _step2.value;
            var inFeed = _this2.posts.some(function (o) {
              return o.id == post.id;
            });
            if (!inFeed) {
              post = trimPost(post);
              _this2.posts.unshift(trimPost(post));
            }
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      },
      setLength: function setLength(length) {
        this.length = length;
      },
      updatePost: function updatePost(_ref2) {
        var id = _ref2.id,
          update = _ref2.update;
        // Update shown posts
        var item = this.posts.find(function (o) {
          return o.id == id;
        });
        if (item) Object.assign(item, update);

        // update new posts
        item = this.new.find(function (o) {
          return o.id == id;
        });
        if (item) Object.assign(item, update);
      },
      newPost: function newPost(_ref3) {
        var roomNames = _ref3.roomNames,
          post = _ref3.post;
        // Post related to this feed
        if (!roomNames.includes(this.roomName)) return;

        // Post already in feed
        var index = this.posts.findIndex(function (o) {
          return o.id == post.id;
        });
        if (index >= 0) return;

        // Post already in new
        index = this.new.findIndex(function (o) {
          return o.id == post.id;
        });
        if (index >= 0) return;
        this.new.unshift(post);
      },
      toggleFullText: function toggleFullText(id) {
        var item = this.posts.find(function (o) {
          return o.id == id;
        });
        if (item) Object.assign(item, {
          isFullText: true
        });
      },
      join: function join(_ref4) {
        var posts = _ref4.posts,
          length = _ref4.length,
          roomName = _ref4.roomName,
          query = _ref4.query;
        this.updateLastUse();
        this.create({
          length: length,
          roomName: roomName,
          query: query
        });
        this.push(posts);
        var feedStores = useFeedsStore();
        if (roomName) feedStores.addRoom(roomName);
      },
      showNew: function showNew() {
        this.unshift(this.new);
        this.updateLastUse();
        this.new = [];
      },
      getNew: function getNew() {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var lastPostDate, query, data;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                lastPostDate = new Date(_this3.posts[0].pubDate);
                query = Object.assign({}, _this3.query);
                query.range = {
                  pubDate: {
                    $gt: lastPostDate
                  }
                };
                _context.next = 5;
                return _this3.$nuxt.$axios.$get('/feed/find', {
                  params: query,
                  progress: false
                }).catch(function (err) {
                  return console.log(err);
                });
              case 5:
                data = _context.sent;
                if (data.posts) {
                  data.posts.forEach(function (post) {
                    _this3.newPost({
                      roomNames: [_this3.roomName],
                      post: post
                    });
                  });
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      clear: function clear() {
        this.posts = [];
        this.new = [];
      }
    }
  })();
}
;